import { Link } from 'react-router'
import { Icon } from '../components/Icon'

export function NotFound() {
  return (
    <div className="page section notfound">
      <p className="eyebrow">Error 404</p>
      <h1 className="page-title">This theory has been suppressed</h1>
      <p className="lede">
        Either it never existed, or somebody got to it first. Both are consistent with what Max has
        been saying for years.
      </p>
      <div className="cluster" style={{ marginTop: 'var(--space-5)' }}>
        <Link to="/theories" className="btn btn-primary">
          <Icon name="arrowLeft" size={16} />
          Back to the archive
        </Link>
        <Link to="/" className="btn btn-ghost">
          Home
        </Link>
      </div>
    </div>
  )
}
